export default class ClubCostCenter {
    constructor() {
        this.id = null;
        this.number = null;
        this.departmentId = null;
        this.departmentName = null;
        this.defaultForDepartment = false;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        const clubCostCenter = new ClubCostCenter();
        clubCostCenter.id = data.id;
        clubCostCenter.number = data.number;
        clubCostCenter.departmentId = data.departmentId;
        clubCostCenter.departmentName = data.departmentName;
        clubCostCenter.defaultForDepartment = data.defaultForDepartment;

        return clubCostCenter;
    }

    serialize() {
        return {
            id: this.id,
            number: this.number === '' ? null : this.number,
            departmentId: this.departmentId,
            defaultForDepartment: this.defaultForDepartment,
        };
    }
}
